const notes = [
  {
    key: 1,
    title: "Meet Patel",
    rating:"★★★★★",
    content:
      "Pellentesquemalesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
  },
  {
    key: 2,
    title: "Rutvik Patel",
    rating:"★★★☆☆",
    content:
      "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
  },
  {
    key: 3,
    title: "Rushi Patel",
    rating:"★★☆☆☆",
    content:
      "Pellentefeugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
  },
  {
    key: 4,
    title: "Vivek Patel",
    rating:"★★★★☆",
    content:
      "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo."
  },
  {
    key: 5,
    title: "Paras",
    rating:"★☆☆☆☆",
    content: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper."
  }
];

export default notes;
